export const DEFAULT_UNSET_MAXIMUM_AGE = Number.MAX_SAFE_INTEGER
export const DEFAULT_UNSET_MINIMUM_AGE = 0
